import {envManager} from './env';
import {AppError} from './errors/app';

const APPSTORE_ID = '1359191114';

const BUNDLE_ID = 'com.coloreight.yourcoach';

export const ASSETS_URL = 'https://assets.yourcoach.health';

export const TOS_URL = `${ASSETS_URL}/tos.pdf`;

export const PRIVACY_POLICY_URL = `${ASSETS_URL}/privacy-policy.pdf`;

export const getAppUrl = () => {
  const webAppUrl = envManager.get('webAppUrl');

  if (!webAppUrl) {
    throw new AppError(
      'webAppUrl is not provided. Did you forget to add into env file?',
    );
  }

  return {
    android: `https://play.google.com/store/apps/details?id=${BUNDLE_ID}`,
    ios: `https://apps.apple.com/app/yourcoach/id${APPSTORE_ID}`,
    web: webAppUrl,
  };
};
